<template>
  <div class="register">
    <div class='container'>
      <div class='row'>
        <div class='col-md-4'>
          <div class="input-group">
              <span class="input-group-text">用户名：</span>
              <input v-model="username" class="form-control"  placeholder="用户名"/>
          </div>
        </div>
        <div class='col-md-4'>
          <div class="input-group">
              <span class="input-group-text">密<span style='margin:0 8px'></span>码：</span>
              <input v-model="password" type="password" class="form-control"  placeholder="密码"/>
          </div>
        </div>
        <div class='col-md-4'>
          <div class="input-group">
              <span class="input-group-text">确<span style='margin:0 8px'></span>认：</span>
              <input v-model="password2" type="password" class="form-control"  placeholder="密码"/>
          </div>
        </div>
        
      </div>
      <div class='row text-center'>
        <div class='col-md-12'>
          <div class="input-group">
              <span class="btn btn-primary form-control"
                    @click='Register'>注册</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import axios from 'axios'

export default {
  name: 'Register',
  data() {
    return {
        username:'',
        password:'',
        password2:''
    }
  },
  methods:{
    Register(){
      var that=this;
      if(this.username==''||this.password==''||this.password2=='')
      {
        that.$toast('请填写用户名密码','fail')
        return;
      }
      if(this.password!=this.password2)
      {
        that.$toast('两次密码输入不一致','fail')
        return;
      }
      //登录 
      that.$myAxios(that,
        {
          method: 'POST',
          url:'/api/User/Register?username='+that.username+'&password='+that.password,
        }
        ,res=>{
          that.$toast(res.msg,'succ');
          that.$router.push('/login');
        }
      )
    }
  },
  computed:{
    
  },
  mounted()
  {
      
  }
}
</script>